import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ListIcon from "@mui/icons-material/List";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { Box, Tab, Tabs } from "@mui/material";
import { PageHeader } from "common";
import I18n from "i18n-js";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

export default function SubmitsTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const { waiver_id } = useParams();

  const getTabValue = () => {
    const path = location.pathname;
    if (path.includes("/analytics")) return 1;
    return 0; // submits list tab
  };

  const [tabValue, setTabValue] = useState(getTabValue());

  useEffect(() => {
    setTabValue(getTabValue());
  }, [location.pathname]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    const basePath = waiver_id ? `/waivers/${waiver_id}/submits` : `/submits`;

    switch (newValue) {
      case 0:
        navigate(basePath);
        break;
      case 1:
        navigate(`${basePath}/analytics`);
        break;
    }
  };

  return (
    <>
      <PageHeader
        avatar={<AssignmentTurnedInIcon />}
        title={I18n.t("Submit.title")}
        sx={{ mt: -3 }}
      />
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          sx={{
            minHeight: 0,
            "& .MuiButton": {
              minHeight: "48px",
            },
          }}
        >
          <Tab
            icon={<ListIcon />}
            label={I18n.t("Submit.list")}
            iconPosition="start"
          />
          <Tab
            icon={<ShowChartIcon />}
            label={I18n.t("Analytics.title")}
            iconPosition="start"
          />
        </Tabs>
      </Box>

      <Box sx={{ mt: 2 }}>
        <Outlet />
      </Box>
    </>
  );
}
